// components/Dashboard.jsx
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import DashboardHome from './DashboardHome';
import CreateCategory from './CreateCategory';
import CreateThemes from './CreateThemes';
import UserList from './UserList';
import CreateContents from './CreateContents';
import ThemeSearcher from './ThemeSearcher';
import ContentSearcher from './ContentSearch';
import CircularMenu from './CircularMenu';
import Billetera from './Billetera'

import createIcon from '../assets/img/crear.png'; // Asegúrate de que esta ruta sea correcta
import searchIcon from '../assets/img/lupa.png';
import folderCIcon from '../assets/img/crear-carpeta.png';
import folderBIcon from '../assets/img/buscar-carpeta.png';
import CategoriaIcon from '../assets/img/categoria.png';   
import simboloDescargadorArchivo from '../assets/img/simbolo-descargador-archivo-gris.png';
import billeteraIcon from '../assets/img/billetera-gris.png';
import NotificationBell from './NotificationBell'; // Importa el nuevo componente
import UserProfile from './UserProfile';
import PublicContentPage from './PublicContentPage';
import FloatingChat from './FloatingChat';

import iconArchivo from '../assets/img/simbolo-descargador-archivo.png';
import iconImagen from '../assets/img/simbolo-de-imagen-n.png';
import iconVideo from '../assets/img/simbolo-de-video.png';
import iconnoimagen from '../assets/img/user.png';

import logoEdeli from '../assets/img/edeli_store.png';

import axios from 'axios';

import { useNavigate } from 'react-router-dom';

import StoreList from './StoreList';

const LogoContainerSidebar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  transition: all 0.3s ease;
`;

const LogoImg = styled.img`
  /* Reducido: 100px cuando está abierto, 35px cuando está colapsado */
  width: ${props => props.collapsed ? '35px' : '100px'}; 
  height: auto;
  object-fit: contain;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

const LogoPublic = styled.img`
  /* Reducido a 30px de altura para que sea sutil en la barra superior */
  height: 80px; 
  width: auto;
  margin-right: auto; 
  align-self: center;

  &:hover {
    transform: scale(1.05); /* Un pequeño efecto al pasar el mouse */
  }

  @media (max-width: 768px) {
    height: 45px; /* Un poco más pequeño en móviles para no romper el layout */
    margin-bottom: 10px;
  }
`;


const SidebarMenu = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-top: 30px;
`;

const SidebarMenuItem = styled.li`
  margin-bottom: 20px;
  transition: all 0.3s ease;
  width: 100%;
  border-radius: 8px;

  background-color: ${props => props.isActive 
    ? 'rgba(128, 128, 128, 0.2)' 
    : 'transparent'};

  box-shadow: ${props => props.isActive 
    ? 'inset 3px 0 0 rgba(128, 128, 128, 0.8)' 
    : 'none'};

  &:hover {
    background-color: rgba(128, 128, 128, 0.15);
    box-shadow: inset 3px 0 0 rgba(128, 128, 128, 0.6);
  }
`;


const DashboardContainer = styled.div`
  display: flex;
  height: 100vh;
  background-color: var(--bg-app);
  
  @media (max-width: 768px) {
    flex-direction: column; /* Apila sidebar arriba y contenido abajo */
  }
`;


const Container = styled.div`
  text-align: center;
  margin-bottom: 20px;
  width:100%
`;

const ProfileContainer = styled.div`
  position: relative;
  top: 5px;
  margin-left: auto; 
  display: flex;
  align-items: center;
  justify-content: flex-end; /* Lo empuja a la derecha en escritorio */
  z-index: 1000;
  padding-right: 20px;
  max-width: fit-content; 

  @media (max-width: 768px) {
    /* Clave: Quitamos el margin-left: 0 y forzamos alineación derecha */
    margin-left: auto; 
    margin-right: 0;
    justify-content: flex-end; 
    margin-bottom: 10px;
    padding-right: 10px;
    width: auto; /* Que solo ocupe lo necesario */
    flex-wrap: nowrap;
  }
`;

const UserProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  justify-content: flex-end; /* Alinea el contenido interno a la derecha */
`;

const ProfileImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
  margin-left: 10px;
  flex-shrink: 0;
  order: 1;

  /* Invierte el icono en modo claro para que se vea oscuro */
  filter: ${props => props.active ? 'none' : 'invert(1) contrast(2)'};
  transition: filter 0.3s ease;
`;

const UserName = styled.span`
  color: var(--text-main);
  font-size: 16px;
  font-weight: bold;
  word-break: break-word; 
  overflow-wrap: break-word;
  max-width: 120px; /* Reducimos un poco para forzar el salto antes */
  text-align: left; /* El nombre se alinea a la derecha */
  line-height: 1.1;
  display: block;

  @media (max-width: 768px) {
    font-size: 14px;
    max-width: 100px; /* Más estrecho en móvil para que baje más rápido */
  }
`;


const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  /* Si está colapsado, centramos el toggle. Si no, alineamos a la izquierda con gap */
  justify-content: ${props => props.collapsed ? 'center' : 'flex-start'};
  gap: 10px;
  cursor: pointer;
  padding: 15px 10px;
  margin-top: 30px;
  border-top: 1px solid rgba(128, 128, 128, 0.2);
  transition: all 0.3s ease;
`;

const SwitchLabel = styled.span`
  font-size: 14px;
  color: var(--text-main);
  font-weight: bold;
`;

const ToggleSlot = styled.div`
  position: relative;
  width: 44px;
  height: 22px;
  background-color: ${props => props.active ? '#555' : '#ccc'};
  border-radius: 20px;
  transition: background-color 0.3s ease;
`;

const ToggleCircle = styled.div`
  position: absolute;
  top: 3px;
  left: ${props => props.active ? '25px' : '3px'};
  width: 16px;
  height: 16px;
  background-color: white;
  border-radius: 50%;
  transition: left 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
`;

const TotalsSidebarContainer = styled.div`
  margin-top: auto; 
  padding: 20px 15px;
  /* Si está en modo oscuro usa #555, si no, un gris clarito */
  background-color: ${props => props.active ? '#555' : '#f0f0f0'}; 
  border-radius: 15px;
  border: 1px solid ${props => props.active ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'};
  margin-bottom: 15px;
  transition: background-color 0.3s ease; /* Para que el cambio de color sea suave */
`;

const TotalsTitle = styled.h4`
  font-size: 13px; /* Un poco más grande */
  margin-bottom: 20px;
  text-align: center;
  color: var(--text-main);
  opacity: 0.8; /* Más visible */
  text-transform: uppercase;
  letter-spacing: 1.2px;
`;

const TotalsGrid = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const TotalItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px; /* Más espacio entre icono, número y texto */
`;

const SidebarStatIcon = styled.img`
  width: 38px;  /* Aumentado de 24px a 38px */
  height: 38px; /* Aumentado de 24px a 38px */
  object-fit: contain;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1); /* Efecto sutil al pasar el mouse */
  }
`;

const StatNumber = styled.span`
  font-size: 22px; /* Aumentado de 16px a 22px */
  font-weight: 800; /* Más grueso */
  color: var(--text-main);
`;

const StatLabel = styled.span`
  font-size: 11px; /* Aumentado de 9px a 11px */
  color: var(--text-main);
  opacity: 0.7;
  font-weight: 500;
`;

const Sidebar = styled.aside`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: ${props => props.collapsed ? '80px' : '285px'};
  background-color: var(--bg-app);
  color: var(--text-main);
  padding: 5px 0 20px 0; /* Quitamos padding lateral para centrar perfecto */
  font-family: 'Roboto', sans-serif;
  border-right: 1px solid rgba(128, 128, 128, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1001;
  overflow-x: hidden;

  @media (max-width: 768px) {
    /* En móvil: si está colapsado se va fuera de la pantalla, si no, se muestra fija */
    width: 285px; 
    left: ${props => props.collapsed ? '-100%' : '0'};
    box-shadow: ${props => props.collapsed ? 'none' : '10px 0 25px rgba(0,0,0,0.3)'};
  }
`;

const ContentArea = styled.div`
  flex-grow: 1;
  padding: 1px;
  overflow-y: auto;
  /* El margen izquierdo debe igualar al ancho de la sidebar */
  margin-left: ${props => props.collapsed ? '80px' : '285px'};
  transition: all 0.3s ease;

  /* Lógica de margen dinámico */
  margin-left: ${props => {
    if (!props.isLoggedIn) return '0'; // Sin login, sin margen
    return props.collapsed ? '80px' : '285px'; // Con login, depende del colapso
  }};
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const ToggleBtn = styled.button`
  background: none;
  border: none;
  color: var(--text-main);
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: ${props => props.collapsed ? 'center' : 'flex-end'};
  width: 100%;
  margin-bottom: 5px;
  padding: 5px;

  &:hover { opacity: 0.7; }
`;

/* Para ocultar el texto cuando esté colapsado */
const Label = styled.span`
  display: ${props => props.collapsed ? 'none' : 'inline'};
  white-space: nowrap;
  margin-left: 10px;
`;

const MobileMenuBtn = styled.button`
  display: none;
  
  @media (max-width: 768px) {
    /* Solo se muestra si el menú está colapsado */
    display: ${props => props.collapsed ? 'block' : 'none'};
    position: fixed;
    top: 20px;
    left: 20px;
    z-index: 1002; /* Mayor que el de la Sidebar (1001) */
    background-color: var(--bg-app);
    color: var(--text-main);
    border: 1px solid rgba(128, 128, 128, 0.5);
    padding: 8px 12px;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  }
`;

const SidebarItemLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: ${props => props.collapsed ? 'center' : 'flex-start'};
  width: 100%;
  padding: ${props => props.collapsed ? '8px 0' : '8px 25px'};
  text-decoration: none;
  color: var(--text-main);
  font-weight: ${props => props.isActive ? '700' : 'normal'};

  /* Modo oscuro activo: texto blanco brillante
     Modo claro activo: texto gris oscuro */
  opacity: ${props => props.isActive ? '1' : '0.75'};
  
  transition: all 0.3s ease;

  &:hover {
    opacity: 1;
  }
`;

const IconoMenu = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0; /* Evita que el icono se aplaste */
  
  /* Si está colapsado, NO hay margen. Si está abierto, separa del texto */
  margin-right: ${props => props.collapsed ? '0' : '15px'}; 
  
  background-color: transparent !important;
  transition: all 0.3s ease;

  /* Filtros de tema */
  [data-theme='light'] & {
    filter: invert(1) contrast(2) !important;
  }
  [data-theme='dark'] & {
    filter: none !important;
  }
`;

const AuthContainer = styled.div`
  display: flex; 
  gap: 15px; 
  align-items: center; 
  justify-content: flex-end; 
  padding: 10px 2%; 
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column; 
    justify-content: center;
    gap: 12px;
  }

  /* Control de orden para los enlaces dentro del contenedor */
  a.btn-login { order: 2; }
  a.btn-register { order: 3; }

  @media (max-width: 768px) {
    a.btn-login { order: 1; }
    a.btn-register { order: 2; }
  }
`;

const HeaderSwitch = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  order: 1; /* En PC va antes de los botones (a la izquierda) */
  
  @media (max-width: 768px) {
    order: 3; /* En móvil va después de los botones (abajo) */
    margin-right: 0;
  }
`;

const ComingSoonBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -10px;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  padding: 3px 7px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  box-shadow: 0 2px 8px rgba(79,70,229,0.4);
  white-space: nowrap;
`;


const Dashboard = ({ isLoggedIn, role, token, username, userId, document, celular, email, theme, toggleTheme, onUsernameUpdate, nombre, apellido }) => {
  const [isBilleteraView, setIsBilleteraView] = useState(false);
  const [contentView, setContentView] = useState('Catalogo');
  const [showReloadWallet, setShowReloadWallet] = useState(false); // Nueva variable de estado
  const [showPay, setShowPay] = useState(false); // Nueva variable de estado
  const [orderWallet, setOrderWallet] = useState(false); // Nueva variable de estado
  const [showChequedBalance, setChequedBalance] = useState(false); // Nueva variable de estado
  const [contentKey, setContentKey] = useState(0);

  const [notificationCount, setNotificationCount] = useState(0);

  const [totalImages, setTotalImages] = useState(0);
  const [totalVideos, setTotalVideos] = useState(0);
  const [totalTexts, setTotalTexts] = useState(0);

 // Definimos isDarkMode basándonos en la prop theme
  const isDarkMode = theme === 'dark';

  // Cambia esto al principio del componente
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth <= 1024);

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);

  const updateNotificationCount = (count) => {
    setNotificationCount(prevCount => prevCount + count);
  };

  const navigate = useNavigate();

  const { slug } = useParams();
  const [storeLogo, setStoreLogo] = useState(null);
  const [storeName, setStoreName] = useState(null);

// NOTA: la prop `document` (número de documento) tapa el `document` global,
// por eso aquí se usa `window.document` para el título y el favicon.
useEffect(() => {
  const setFavicon = (href) => {
    let favicon = window.document.querySelector("link[rel~='icon']");
    if (!favicon) {
      favicon = window.document.createElement('link');
      favicon.rel = 'icon';
      window.document.head.appendChild(favicon);
    }
    favicon.href = href;
  };

  if (!slug) {
    window.document.title = 'Edeli Store';
    setStoreLogo(null);
    setStoreName(null);
    setFavicon(logoEdeli); // Resetea el favicon al logo de Edeli
    return;
  }

  const fetchStore = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/store/${slug}`);
      setStoreLogo(res.data.store.logo);
      setStoreName(res.data.store.name);
      window.document.title = res.data.store.name || 'Edeli Store';

      if (res.data.store.logo) {
        setFavicon(res.data.store.logo);
      }
    } catch {
      /* si falla, se queda con el logo default */
    }
  };

  fetchStore();
}, [slug]);

  const displayLogo = storeLogo || logoEdeli;
  const basePath = slug ? `/creador/${slug}` : '/dashboard';
  const sidebarVisible = isLoggedIn;

  // Ruta del perfil propio (misma ruta que maneja <UserProfile /> más abajo)
  const profilePath = `${basePath}/users/${userId}`;

  const menuItems = {
    Admin: [
      { label: 'Contenido', path: basePath },
      { label: 'Crear Contenido', path: `${basePath}/create-contents` },
      { label: 'Tiendas', path: `${basePath}/stores` },
      { label: 'Temática', path: `${basePath}/search-theme` },
      { label: 'Mi Perfil', path: profilePath },
      { label: 'Usuarios', path: `${basePath}/users` },
    ],
    Creador: [
      { label: 'Contenido', path: basePath },
      { label: 'Crear Contenido', path: `${basePath}/create-contents` },
      { label: 'Tiendas', path: `${basePath}/stores` },
      { label: 'Temática', path: `${basePath}/search-theme` },
      { label: 'Mi Perfil', path: profilePath },
    ],
    Usuario: [
      { label: 'Contenido', path: basePath },
      { label: 'Tiendas', path: `${basePath}/stores` },
      { label: 'Temática', path: `${basePath}/search-theme` },
      { label: 'Mi Perfil', path: profilePath },
    ],
  };

  const menuItemsWallet = {
    Admin: [
      { label: 'Billetera', path: '/dashboard/' },
      { label: 'Recarga Billetera', path: '/dashboard/reload-wallet' },
      { label: 'Solicitar Recargar Saldo', path: '/dashboard/order-wallet' },
      { label: 'Transferencia', path: '/dashboard/pay' },
      { label: 'Chequear balance', path: '/dashboard/check-balance' },
    ],
    Creador: [
      { label: 'Billetera', path: '/dashboard/billetera' },
      { label: 'Solicitar Recargar Saldo', path: '/dashboard/order-wallet' },
      { label: 'Transferencia', path: '/dashboard/pay' },
    ],
    Usuario: [
     
    ],
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = slug ? `/login?redirect=/creador/${slug}` : '/login';
  };

  const currentRole = role;
  const location = useLocation();

  const Catalogo = (value) => {
    setContentView(value)
    if (value === 'Catalogo') {
      navigate(basePath);
    }
  };

  useEffect(() => {
    setIsBilleteraView(contentView === 'saldo');
    setShowReloadWallet(location.pathname.startsWith('/dashboard/reload-wallet'));
    setShowPay(location.pathname.startsWith('/dashboard/pay'));
    setOrderWallet(location.pathname.startsWith('/dashboard/order-wallet'));
    setChequedBalance(location.pathname.startsWith('/dashboard/check-balance'));
    
  }, [contentView, location.pathname]);

  useEffect(() => {
    const fetchThemes = async () => {
      try {
        await axios.get(`${process.env.REACT_APP_API_URL}/api/user/list-themes`, {
          headers: { authorization: `Bearer ${token}` }
        });
       
      } catch (error) {
        console.error('Error fetching themes:', error);
      }
    };

    const fetchTotals = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/content-totals`, {
          headers: { Authorization: `Bearer ${token}` } // Agregamos el token por seguridad
        });
        setTotalImages(response.data.images);
        setTotalVideos(response.data.videos);
        setTotalTexts(response.data.texts);
      } catch (error) {
        console.error('Error fetching totals:', error);
      }
    };

    if (token) {
      fetchThemes();
      fetchTotals();
    }
  }, [token]);

  
  useEffect(() => {
    if (!userId || !token) return;

    const checkNewNotifications = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/user/notifications/${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (Array.isArray(res.data)) {
          setNotificationCount(res.data.length);
        }
      } catch (err) {
        console.error('Error checking notifications:', err);
      }
    };

    checkNewNotifications();
    const interval = setInterval(checkNewNotifications, 15000);
    return () => clearInterval(interval);
  }, [userId, token]);

  return (
    <DashboardContainer>
      {sidebarVisible && (
      <>

        <MobileMenuBtn 
          collapsed={isCollapsed} 
          onClick={() => setIsCollapsed(false)}
        >
          ☰ Menu
        </MobileMenuBtn>
        <Sidebar collapsed={isCollapsed}>

        

         <ToggleBtn collapsed={isCollapsed} onClick={toggleSidebar}>
          {/* Si es móvil Y está colapsado, muestra el icono. 
              Si es escritorio y está colapsado, solo muestra la flecha o icono. */}
          {isCollapsed ? '☰' : (window.innerWidth <= 768 ? '✕' : '⬅')}
        </ToggleBtn>

          {/* 1. LOGO EN SIDEBAR (ARRIBA DEL TODO) */}
            <LogoContainerSidebar>
              <LogoImg src={displayLogo} collapsed={isCollapsed} alt={storeName || "Logo Edeli"} />
            </LogoContainerSidebar>

        {/* <h2 style={{ 
          fontSize: '20px', 
          textAlign: isCollapsed ? 'center' : 'left',
          display: isCollapsed && window.innerWidth > 768 ? 'none' : 'block' 
        }}>
          Menu
        </h2> */}

        {!isCollapsed && (
        <RadioButtonContainer>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '20px' }}>
            <img src={simboloDescargadorArchivo} alt="Catalogo Icon" style={{ width: '60px', marginBottom: '10px' }} />
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <RadioButton
                type="radio"
                name="contentView"
                value="Catalogo"
                checked={contentView === 'Catalogo'}
                onChange={(e) => Catalogo(e.target.value)}
                style={{ width: '20px', height: '20px' }} // Aumentamos el tamaño del radio button
              />
              <RadioButtonLabel>Catalogo</RadioButtonLabel>
            </div>
          </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', opacity: 0.5, cursor: 'not-allowed' }}>
              <img
                src={billeteraIcon}
                alt="Billetera Icon"
                style={{ width: '60px', marginBottom: '10px', filter: 'grayscale(1)' }}
              />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <RadioButton
                  type="radio"
                  name="contentView"
                  value="saldo"
                  checked={contentView === 'saldo'}
                  disabled={true}
                  style={{ width: '20px', height: '20px', cursor: 'not-allowed' }}
                />
                <RadioButtonLabel style={{ cursor: 'not-allowed' }}>Billetera</RadioButtonLabel>
              </div>
              {/* Badge Próximamente */}
              <ComingSoonBadge>Próximamente</ComingSoonBadge>
            </div>
        </RadioButtonContainer>
        )}
        <SidebarMenu>
        {!isBilleteraView ? (
          currentRole && menuItems[currentRole] ? (
            // Reemplaza el map de menuItems por este:
            menuItems[currentRole].map((item, index) => (
              <SidebarMenuItem 
                key={index} 
                isActive={location.pathname === item.path}
                onClick={() => {
                  if (window.innerWidth <= 768) setIsCollapsed(true);
                  // Si ya estamos en esa ruta, forzamos recarga incrementando la key
                  if (location.pathname === item.path) {
                    setContentKey(prev => prev + 1);
                  }
                }}
              >
                <SidebarItemLink to={item.path} isActive={location.pathname === item.path}>
                  {item.label.includes('Crear Contenido') ? (
                    <IconoMenu src={createIcon} alt="Crear" collapsed={isCollapsed}/>
                  ) : item.label.includes('Crear Tematica') ? (
                    <IconoMenu src={folderCIcon} alt="Carpeta" collapsed={isCollapsed} />
                  ) : item.label.includes('Tiendas') ? (
                    <IconoMenu src={CategoriaIcon} alt="Tiendas" collapsed={isCollapsed} />
                  ) : item.label.includes('Temática') ? (
                    <IconoMenu src={folderBIcon} alt="Carpeta" collapsed={isCollapsed} />
                  ) : item.label.includes('Mi Perfil') ? (
                    <IconoMenu src={iconnoimagen} alt="Mi Perfil" collapsed={isCollapsed} />
                  ) : item.label.includes('Usuarios') ? (
                    <IconoMenu src={iconnoimagen} alt="Usuarios" collapsed={isCollapsed} />
                  ) : item.label.includes('Crear Categoría') ? (
                    <IconoMenu src={CategoriaIcon} alt="Carpeta" collapsed={isCollapsed} />
                  ) : (
                    <IconoMenu   src={searchIcon} alt="Buscar" collapsed={isCollapsed} />
                  )}
                  <Label collapsed={isCollapsed}>{item.label}</Label>
                  </SidebarItemLink>
              </SidebarMenuItem>
            ))
          ) : (
            <p>No tienes permisos para ver este menú</p>
          )
          ) : (
            menuItemsWallet[currentRole].map((item, index) => (
              <SidebarMenuItem key={index} onClick={() => window.innerWidth <= 768 && setIsCollapsed(true)}>
                <SidebarItemLink to={item.path}>
                  {item.label.includes('Billetera') ? (
                    <IconoMenu src={createIcon} alt="Crear" collapsed={isCollapsed} />
                  ) : item.label.includes('Recarga Billetera') ? (
                    <IconoMenu src={folderCIcon} alt="Carpeta" collapsed={isCollapsed} />
                  ) : item.label.includes('Transferencia') ? (
                    <IconoMenu src={folderBIcon} alt="Carpeta" collapsed={isCollapsed} />
                  ) : item.label.includes('Chequear Balance') ? (
                    <IconoMenu src={folderBIcon} alt="Carpeta" collapsed={isCollapsed} />
                  ) : (
                    <IconoMenu src={searchIcon} alt="Buscar" collapsed={isCollapsed} />
                  )}
                  {item.label}
                  </SidebarItemLink>
              </SidebarMenuItem>
            ))
          )}
        </SidebarMenu>
    
        <SwitchContainer onClick={toggleTheme} collapsed={isCollapsed}>
          <ToggleSlot active={isDarkMode}>
            <ToggleCircle active={isDarkMode}>
              {isDarkMode ? '🌙' : '☀️'}
            </ToggleCircle>
          </ToggleSlot>
          
          {/* Envolvemos el texto en el Label que ya sabe ocultarse */}
          <Label collapsed={isCollapsed}>
            <SwitchLabel>{isDarkMode ? 'Oscuro' : 'Claro'}</SwitchLabel>
          </Label>
        </SwitchContainer>
       {/* --- SECCIÓN DE TOTALES --- */}
       {!isCollapsed && role === 'Admin' && (
        <TotalsSidebarContainer active={isDarkMode}>
          <TotalsTitle>Estadísticas Globales</TotalsTitle>
          <TotalsGrid>
            <TotalItem>
              <SidebarStatIcon src={iconImagen} alt="Imágenes" />
              <StatNumber>{totalImages}</StatNumber>
              <StatLabel>Fotos</StatLabel>
            </TotalItem>
            
            <TotalItem>
              <SidebarStatIcon src={iconVideo} alt="Videos" />
              <StatNumber>{totalVideos}</StatNumber>
              <StatLabel>Videos</StatLabel>
            </TotalItem>
            
            <TotalItem>
              <SidebarStatIcon src={iconArchivo} alt="Archivos" />
              <StatNumber>{totalTexts}</StatNumber>
              <StatLabel>Archivos</StatLabel>
            </TotalItem>
          </TotalsGrid>
        </TotalsSidebarContainer>
        )}
          {/* <PhindChatComponent /> */}
        {/* <LogoutButton onClick={handleLogout}>Mas</LogoutButton> */}
      </Sidebar>
     </>
    )}
      {/* <VerticalSeparator /> */}
      <ContentArea collapsed={isCollapsed} isLoggedIn={sidebarVisible}>
        <Container>
          
       {isLoggedIn ? (
          <ProfileContainer>
            <NotificationBell 
              notificationCount={notificationCount} 
              userId={userId} 
              token={token}  
              updateNotificationCount={updateNotificationCount}
              theme={theme}  
            />
            <UserProfileWrapper>
              <ProfileImage src={iconnoimagen} alt="Profile" active={isDarkMode} />
              <UserName>{username}</UserName>
            </UserProfileWrapper>
            <CircularMenu handleLogout={handleLogout} userId={userId} theme={theme}  />
          </ProfileContainer>
       // ... dentro de tu bloque !isLoggedIn ...
      ) : (
        <AuthContainer>
          <LogoPublic src={displayLogo} alt={storeName || "Logo"} />

          {/* El Switch ya tiene su order en el Styled Component */}
          <HeaderSwitch onClick={toggleTheme}>
            <ToggleSlot active={isDarkMode} style={{ width: '38px', height: '18px' }}>
              <ToggleCircle active={isDarkMode} style={{ width: '12px', height: '12px', top: '3px', left: isDarkMode ? '22px' : '3px' }}>
                {isDarkMode ? '🌙' : '☀️'}
              </ToggleCircle>
            </ToggleSlot>
            <SwitchLabel style={{ fontSize: '12px' }}>
              {isDarkMode ? 'Oscuro' : 'Claro'}
            </SwitchLabel>
          </HeaderSwitch>
          
          <Link 
            to={slug ? `/login?redirect=/creador/${slug}` : '/login'} 
            className="btn-login" // Clase para el CSS
            style={{ 
              textDecoration: 'none', 
              color: 'var(--text-main)', 
              padding: '8px 15px', 
              border: '1px solid var(--text-main)', 
              borderRadius: '5px', 
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            Iniciar Sesión
          </Link>

          <Link 
            to={slug ? `/register?redirect=/creador/${slug}` : '/register'} 
            className="btn-register" // Clase para el CSS
            style={{ 
              textDecoration: 'none', 
              color: 'white', 
              backgroundColor: '#555', 
              padding: '8px 15px', 
              borderRadius: '5px', 
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            Registrarse
          </Link>
        </AuthContainer>
      )}
        
        {contentView === 'Catalogo' ? (
        <>
          
          {isLoggedIn && role === 'Admin' ? (
            <>
              {location.pathname === basePath && (
                      <DashboardHome
                      key={contentKey} 
                      isLoggedIn={isLoggedIn} 
                      role={role} 
                      token={token}
                      username={username}
                      nombre={nombre}
                      apellido={apellido}
                      storeName={storeName}
                      userId={userId}
                      updateNotificationCount={updateNotificationCount}
                      theme={theme}
                      isSidebarOpen={!isCollapsed}
                    />
              )}
              {location.pathname === `${basePath}/create-contents` && (
                <CreateContents isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
              {location.pathname.startsWith(`${basePath}/edit-content/`) && (
                <CreateContents isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
              {location.pathname === `${basePath}/create-category` && (
                <CreateCategory isLoggedIn={isLoggedIn} role={role} token={token} />
              )}
              {location.pathname === `${basePath}/create-themes` && (
                <CreateThemes isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
              {location.pathname === `${basePath}/stores` && (
                <StoreList theme={theme} />
              )}
              {location.pathname === `${basePath}/search-theme` && (
                <ThemeSearcher isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
              {location.pathname === `${basePath}/search-content` && (
                <ContentSearcher isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
              {location.pathname === `${basePath}/content/:id` && (
                <PublicContentPage isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
              
              {location.pathname.startsWith(`${basePath}/users/`) && (
              <UserProfile 
                  token={token} 
                  theme={theme}
                  userId={location.pathname.split(`${basePath}/users/`)[1]}
                  currentUserId={userId}
                  currentUserRole={role}              
                  onUsernameUpdate={onUsernameUpdate}
                />
              )}
              {location.pathname === `${basePath}/users` && (
                <UserList isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
            </>
          ) : (
            <>
              {location.pathname === basePath && (
                <DashboardHome
                key={contentKey} 
                isLoggedIn={isLoggedIn} 
                role={role} 
                token={token}
                username={username}
                nombre={nombre}
                apellido={apellido}
                storeName={storeName}
                updateNotificationCount={updateNotificationCount}
                userId={userId}
                theme={theme}
                isSidebarOpen={!isCollapsed} 
              />
              )}
             {location.pathname === `${basePath}/create-contents` && (
                <CreateContents isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
              {location.pathname.startsWith(`${basePath}/edit-content/`) && (
                <CreateContents isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
               {location.pathname === `${basePath}/stores` && (
                <StoreList theme={theme} />
              )}
               {location.pathname === `${basePath}/search-theme` && (
                <ThemeSearcher isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
               {location.pathname === `${basePath}/search-content` && (
                <ContentSearcher isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
              {location.pathname === `${basePath}/content/:id` && (
                <PublicContentPage isLoggedIn={isLoggedIn} role={role} token={token} theme={theme} />
              )}
              {location.pathname.startsWith(`${basePath}/users/`) && (
                <UserProfile 
                  token={token} 
                  theme={theme}
                  userId={location.pathname.split(`${basePath}/users/`)[1]}
                  currentUserId={userId}
                  currentUserRole={role}              
                  onUsernameUpdate={onUsernameUpdate}
                />
              )}
            </>
          )}
          </>
          ) : (
            <Billetera 
            isLoggedIn={isLoggedIn} 
            role={role} token={token} 
            showReloadWallet={showReloadWallet} 
            showPay={showPay} 
            orderWallet={orderWallet} 
            userId={userId} 
            document={document} 
            celular={celular} 
            email={email}
            showChequedBalance={showChequedBalance}  
            />
          )}
       </Container>
      </ContentArea>

      {isLoggedIn && <FloatingChat username={username} />}
      
    </DashboardContainer>
  );
};

const RadioButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

const RadioButton = styled.input`
  margin-right: 10px;
`;

const RadioButtonLabel = styled.label`
  color: var(--text-main);;
  margin-right: 20px;
`;


export default Dashboard;